module.exports = __webpack_public_path__ + "img/cs.ec66ea49.svg";